import React, { useContext, useEffect } from "react";
import { CycleFilterContext } from "./context/CycleFilterContext";
import { PVAOverviewContext } from "./context/PVAOverviewContext";
import PackageOverview from "../packageOverview/PackageOverviewv2";
import { getRefreshInterval } from "./utils/utils";
import { getNewRefreshInterval } from "./utils/utils";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../outboundAmzl/util/Util";

const PVAView = (data) => {
  const { cycles } = useContext(CycleFilterContext);
  const { dispatch } = useContext(PVAOverviewContext);

  const getPVAData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_PVA_DATA",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          processName: data.pva.processName,
          baseUrl: baseUrl,
        },
      });
    });
  };
  const getPlannedHoursData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_PLANNED_HOURS_DATA",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          processName: data.pva.processName,
          baseUrl: baseUrl,
        },
      });
    });
  };

  const getDynamicPlanData = () => {
    dispatch({
      type: "LOAD_DYNAMIC_PLAN_DATA",
      data: {
        dispatcher: dispatch,
      },
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getPVAData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getPVAData();
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getPlannedHoursData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getPlannedHoursData();
        }
      }, getNewRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  useEffect(() => {
    getDynamicPlanData();
    const interval = setInterval(() => {
      if (!document.hidden) {
        getDynamicPlanData();
      }
    }, getNewRefreshInterval());
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <PackageOverview view={{ processName: data.pva.processName }} />
    </div>
  );
};

export default PVAView;



// WEBPACK FOOTER //
// ./src/components/overview/PVAViewv3.js